module.exports = __webpack_public_path__ + "img/collection-memoireRingsHalfSetMemories.21fdd70.webp";